import { Body, Box, IconButton, Link } from '@hover/blueprint';
import { Button } from '@hover/blueprint/brand';
import { space } from '@hover/blueprint/foundation';
import { iX } from '@hover/icons';
import React, { useRef, useState } from 'react';
import CookieConsent from 'react-cookie-consent';
import './cookieStyles.css';

const HoverCookieConsent: React.FC = () => {
  const [isVisible, setVisible] = useState<'show' | 'byCookieValue' | 'hidden'>(
    'byCookieValue',
  );

  const ref = useRef(null);

  const onClose = () => {
    setVisible('hidden');
  };

  return (
    <CookieConsent
      ref={ref}
      visible={isVisible}
      style={{
        width: 'auto',
        left: 15,
        backgroundColor: 'white',
        marginBottom: 15,
        boxShadow: '0px 6px 11px 0px rgba(181, 181, 181, 0.34)',
        borderRadius: 8,
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: space[500],
      }}
      contentStyle={{
        margin: 0,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
      buttonWrapperClasses="cookie-button-class"
      ButtonComponent={({ onClick }) => (
        <Box flexDir="column">
          <Button
            colorScheme="primary"
            // marginBottom={500}
            w="100%"
            onClick={onClick as React.MouseEventHandler<HTMLButtonElement>}
          >
            Accept all cookies
          </Button>
          {/* <Button colorScheme="primary" variant="outline" w="100%">
            Cookie settings
          </Button> */}
        </Box>
      )}
    >
      <Body size={500} maxW="325px" fontWeight={400} my="20px" mt={0}>
        <IconButton
          float="right"
          label="Close"
          iconSize="medium"
          cursor="pointer"
          onClick={onClose}
          icon={iX}
          size="large"
          shape="square"
          fill="minimal"
          color="neutral"
          m={0}
          alignSelf="flex-end"
          w="auto"
          h="auto"
          sx={{ div: { p: 0, w: 'auto', h: 'auto' }, svg: { margin: 0 } }}
        />
        This website uses cookies to enhance user experience and to analyze
        performance and traffic on our website. We also share information about
        your use of our site with our social media, advertising and analytics
        partners.{' '}
        <Link cursor="pointer" href="/cookie-policy/" color="primary.600">
          More info
        </Link>
      </Body>
    </CookieConsent>
  );
};

export default HoverCookieConsent;
